import { createApp as createVueApp } from 'vue';
import { VueQueryPlugin } from '@tanstack/vue-query';
import { createPinia } from 'pinia';
import i18next from 'i18next';
import I18NextVue from 'i18next-vue';

import { provideModal } from '@shared/modal';
import { DateLib } from '@shared/lib';
import { setupI18N } from '@shared/i18n';
import { provideAppContext } from '@shared/app-context';
import { MainPage } from '@pages/main/desktop';
import { withProviders } from './providers';

import '@shared/css/main.css';
import '@shared/css/desktop.css';

export function createApp(pageContext: any) {
  const { pageProps, locale } = pageContext;

  const pinia = createPinia();
  const app = createVueApp(MainPage, pageProps);

  app
    .use(pinia)
    .use(VueQueryPlugin)
    .use(provideModal)
    .use(provideAppContext, pageContext)
    .use(I18NextVue, { i18next });

  withProviders(app);

  function isReady() {
    return setupI18N(locale).then(() => app);
  }

  function mount() {
    isReady().then(() => {
      DateLib.initDayjs(i18next.language);
      app.mount('#app');
    });
  }

  return { app, mount, isReady };
}
